<footer class="mdsf-footer">
  <div class="container {{ alignClass }}">
    <div class="button-group">
      @for (link of links; track link) {
        <div class="button cursor-pointer"
          [routerLink]="['/', 'seite', link.url]">
          <a [routerLink]="['/', 'seite', link.url]">{{ link.title }}</a>
        </div>
      }
      <div class="button cursor-pointer" (click)="feedbackControlService.openFeedbackModal()">
        <a>FEEDBACK</a>
      </div>
    </div>
  </div>
</footer>
